<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card success-card">
          <div class="card-body green">You successfully added a new organization!</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Create Organization</strong>
          </div>
          <b-form @submit.prevent="registerOrganization">
            <b-form-group>
              <label for="organization_name">Organization Name</label>
              <b-form-input
                type="text"
                v-validate="'required'"
                v-model="name"
                name="organization_name"
                placeholder="Enter the organization name"
                :class="{'has-error': errors.has('organization_name')}"
              >
              </b-form-input>
              <span class="red">{{ errors.first('organization_name') }}</span>
            </b-form-group>
          <div class="form-actions">
            <b-button type="submit" name="submit" variant="primary">Submit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Register',
  data () {
    return {
      name: '',
      success: false
    }
  },
  methods: {
    /**
     * Submits the form information to the backend API once submit button is pressed. The information is passed through a validator to make sure they meet the required details.
     */
    registerOrganization: function () {
      let self = this

      const { name } = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post(`${process.env.VUE_APP_API_URL}api/organizations`, {
            name
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.success = true
              window.scrollTo(0, 0)
            })
            .catch(function (error) {
              console.log(error.response)
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
